import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './State';

export const cameraReducer = createSlice({
  name: 'camera',
  initialState,
  reducers: {
    cameraImageAction: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.image = action.payload;
    },
    frontCardImageAction: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.frontCardImage = action.payload;
    },
    backCardImageAction: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.backCardImage = action.payload;
    }
  }
});

export const { cameraImageAction, frontCardImageAction, backCardImageAction } = cameraReducer.actions;

export default cameraReducer.reducer;
